import type {Dispatch, ThunkAction} from 'src/reducers';

import * as reduxApi from 'src/utils/redux-api-v2';


export const verifyCreds =
  (creds: unknown): ThunkAction<unknown> =>
  (dispatch: Dispatch) =>
    dispatch(
      reduxApi.post('onboard/validate-credentials', {
        credentials: JSON.stringify(creds),
      }),
    );
